/**
 * 点击事件兼容处理
 *
 * 背景：部分低版本 / 定制 WebView（鸿蒙、部分 vivo 机型等）存在两类问题：
 * 1. click 事件不触发或延迟严重 —— 所以项目里大量使用 touchstart；
 * 2. touchstart 上 preventDefault 后仍然会补发一个合成 click —— 会造成重复触发。
 *
 * 这里统一提供一套“触摸优先 + click 兜底 + 去重”的处理：
 * - 可滚动列表里的行：tapStart / tapMove / tapEnd（touchend 才算点击，滑动不算），避免和滚动冲突；
 * - 非滚动区域的按钮：仍用 @touchstart.prevent + tapDirect，再用 tapFallback 绑定 click 兜底；
 * - 所有触摸触发都会登记时间戳，紧随其后的合成 click 会被 tapFallback 丢弃。
 */

const MOVE_LIMIT = 10 // 位移超过该像素视为滚动，不算点击
const GHOST_CLICK_MS = 700 // 触摸后这段时间内的 click 视为浏览器合成事件，丢弃

let startX = 0
let startY = 0
let scrolled = false
let lastTapAt = 0
let hasTouch = false

// 只要页面收到过 touchstart，就说明该机型的触摸事件是正常的，
// 之后一律以触摸为准、彻底禁用 click 兜底。
// （否则在“preventDefault 拦不住合成 click”的机型上，长按后补发的 click 会误触到刚弹出来的浮层）
if (typeof document !== 'undefined') {
	document.addEventListener('touchstart', function () { hasTouch = true }, true)
}

// 该机型的触摸事件是否可用
export function isTouchDevice() {
	return hasTouch
}

// 触摸已处理过一次点击，登记时间戳供 click 兜底去重
function markTap() {
	lastTapAt = Date.now()
}

export function tapStart(e) {
	const touch = e.touches && e.touches[0]
	startX = touch ? touch.clientX : 0
	startY = touch ? touch.clientY : 0
	scrolled = false
}

export function tapMove(e) {
	const touch = e.touches && e.touches[0]
	if (!touch) return
	if (Math.abs(touch.clientX - startX) > MOVE_LIMIT || Math.abs(touch.clientY - startY) > MOVE_LIMIT) {
		scrolled = true
	}
}

// 可滚动区域内的点击：滑动过就不算点击
export function tapEnd(e, fn, arg) {
	if (scrolled) return
	markTap()
	fn(arg)
}

// 非滚动区域，touchstart 直接触发（配合 @touchstart.prevent 使用）
export function tapDirect(e, fn, arg) {
	markTap()
	fn(arg)
}

// click 兜底：只有触摸事件完全不生效的机型才会真正执行
export function tapFallback(e, fn, arg) {
	if (hasTouch) return
	if (Date.now() - lastTapAt < GHOST_CLICK_MS) return
	fn(arg)
}
